import "./../../styles.css";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { Row, Col, Card } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import { UNITS } from "components/Common/Constants";
import { VEHICLE_ANALYTICS } from "components/Common/svgIconComponents";
import { getVehicleDistance } from "apis/vehicleAnalyticsApis";
import VehicleImageWidget from "components/Common/Widgets/VehicleImageWidget";
import BarChartGraph from "../../barChart";

const Odometer = ({ selectedDateRange, datePickerType }) => {
  const eol = useSelector((state) => state.eol);
  const vehicleDetails = eol?.vehicleDetails;

  const {
    data: vehicleDistanceData,
    // isLoading: vehicleDistanceLoading,
    // isError: vehicleDistanceIsError,
    // error: vehicleDistanceError,
  } = useQuery({
    queryKey: [
      "vehicleDistance",
      vehicleDetails?.vehImei,
      selectedDateRange,
      datePickerType,
    ],
    queryFn: () =>
      getVehicleDistance(
        vehicleDetails?.vehImei,
        selectedDateRange,
        datePickerType
      ),
    keepPreviousData: true,
    enabled: !!(vehicleDetails?.vehImei && selectedDateRange && datePickerType),
    staleTime: 1 * 10 * 60 * 1000,
  });

  const odoTitle = (
    <div className="vaCardTitle">
      <VEHICLE_ANALYTICS.ODOMETER />
      <span>Odometer</span>
    </div>
  );
  const totalDistSubTitle = (
    <div>
      <span>Total Distance </span>
      <span>
        {" "}
        {datePickerType === "week" || datePickerType === "month" ? ` : ` : ""}
      </span>
      <span>
        {vehicleDistanceData?.distanceTravelled} {UNITS.KM}
      </span>
    </div>
  );
  const distGraphTitle = (
    <div className="vaCardTitle">
      <BarChartOutlined style={{ fontSize: "32px" }} />
      <span>
        Distance{" "}
        {/* {datePickerType === "week" || datePickerType === "month"
          ? `${datePickerType[0].toUpperCase() + datePickerType.slice(1)}ly`
          : ""} */}
      </span>
    </div>
  );

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8} lg={6}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Card className="vaCards" style={{ height: "100%" }}>
                <Row style={{ padding: "10px" }}>
                  <Col span={24}>
                    <VehicleImageWidget
                      vehicleDetails={vehicleDetails}
                      showDetails={true}
                      showOdometer={false}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col span={24}>
              <Card className="vaCards" title={odoTitle}>
                <div
                  style={{
                    minHeight: "90px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: "36px" }} className="fs1 bold">
                    {vehicleDistanceData?.odometerReading}
                  </span>
                  <span style={{}} className="fs1">
                    {UNITS.KM}
                  </span>
                </div>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col xs={24} md={16} lg={18}>
          <Card
            bordered={true}
            className="vaCards trips-distance-graph-card h100"
            title={distGraphTitle}
            extra={totalDistSubTitle}
          >
            <BarChartGraph
              data={vehicleDistanceData?.timeDistanceBreakUps || []}
              startTime={selectedDateRange[0]}
              endTime={selectedDateRange[1]}
              datePickerType={datePickerType}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Odometer;
